import { useMemo, useState } from "react";
import { getTourDetails } from "../store/global/selectors";
import { useDispatch, useSelector } from "react-redux";
import { invokeGetService, invokePostService, toggleTourNextStep, triggerTour } from "../store/global/actions";
import { ACTIONS, EVENTS, STATUS } from "react-joyride";

const useTour = () => {
    const {currentTour, attributes, triggerNextStep, initStart, config } = useSelector(getTourDetails);
    const dispatch = useDispatch();

    
    // -------------------- Hooks --------------------
    const [run, setRun] = useState(false);
    const [steps, setSteps] = useState([]);
    const [stepIndex, setStepIndex] = useState(0)
    const [isDisableIncreament, setDisableIncreament] = useState(false)

    /**
     * Function for getting the progress of tour in a particular screen/module and modify the steps based on the progress.
     * If the value of the screen or module is equal to the number of available steps, the UI tour will not be displayed.
     * If the value of the screen or module is less than the total number of steps, the UI tour will start from the next uncompleted step.
     * @param {module} is the name of module in which UI Tour need to be run.
     */
    const getProcessedSteps = async (module) => {
        const {data} = await dispatch(invokeGetService('getOrPostUITour'));
        let currentSteps = config?.[currentTour];
        
        if(initStart && currentSteps){
            let stepLen = currentSteps.length;
            const initSteps = [...currentSteps];

            for(let i=0; i < stepLen; i++){
                let target = initSteps[i]?.target;
                let element;
                if(initSteps[i].shadow){
                    element = document
                        .querySelector(initSteps[i].shadowRoot)
                        ?.shadowRoot
                        ?.querySelector(target);
                        console.log(element, element.getBoundingClientRect(), 'this is element')
                }else{
                    element = document.querySelector(target);
                }

                
                if(!element){
                    // Remove the step if the element is not found
                    initSteps.splice(i, 1);
                    // Decrement the index and length after removal
                    i--;
                    stepLen--;
                }
            }
            console.log({initSteps, currentSteps, currentTour, module})
            setSteps(initSteps)
            setRun(true)

            return true
        }

        if(data?.[module]){
            if(currentSteps?.length > data?.[module]){
                const newSteps = currentSteps.slice(data?.[module], currentSteps?.length);
                currentSteps = newSteps;
            }else{
                currentSteps = []
            }
        }
        
        let stepLen = currentSteps.length;
        for(let i=0; i < stepLen; i++){
            let target = currentSteps[i]?.target;
            const element = document.querySelector(target);
            
            if(!element){
                // Remove the step if the element is not found
                currentSteps.splice(i, 1);
                // Decrement the index and length after removal
                i--;
                stepLen--;
            }
        }

        setSteps(currentSteps)
        setRun(true)

    }

    const handleJoyrideCallback = (data) => {
        const { status, size, type, index, action } = data;
        console.log(data,'this is data')
        if([STATUS.FINISHED, STATUS.SKIPPED].includes(status) || [ACTIONS.CLOSE].includes(action)){
            dispatch(invokePostService('getOrPostUITour', {key: currentTour, steps: size}))
            setTimeout(() => dispatch(triggerTour({currentTour: '', initStart: false })), 500)
        }else if([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type) && !isDisableIncreament){
            const nextStepIndex = index + (action === ACTIONS.PREV ? -1 : 1);
            setStepIndex(nextStepIndex)
        }
    }

    useMemo(() => {
        if(currentTour && currentTour !== ''){
            setRun(false)
            setStepIndex(0)
            
            setTimeout(() => {
                getProcessedSteps(currentTour);
            },400)
        }else{
            setRun(false)
        }
    },[currentTour])

    useMemo(() => {
        if(triggerNextStep){
            
            setDisableIncreament(true)
            setRun(false)
            dispatch(toggleTourNextStep(false))
            
            setTimeout(() =>{
                setStepIndex(prev => prev + 1);
                setRun(true)
                setDisableIncreament(false)
            }, 400)
        }
    }, [triggerNextStep])

    useMemo(() => {
        if(steps && steps.length === 0){
            setTimeout(() => {
                dispatch(triggerTour({currentTour: ''}))
            },200)
        }
    },[steps])

    return {run, steps, stepIndex, otherAttributes: attributes, handleJoyrideCallback, config}
}

export default useTour;